const scrollTo = (selector, block = 'start') => {
  // eslint-disable-next-line no-undef
  const element = document.querySelector(selector)

  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block,
    })
  }
}

export default scrollTo
